import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { BarChart } from '@mui/x-charts/BarChart';
import { useTheme } from '@mui/material/styles';

import { CanalDistribuicaoViewProps, mapDispatchToCanalDistribuicaoProps, mapStateToCanalDistribuicaoProps } from "../../canalDist/canalDist.controll";
import { connect } from 'react-redux';
import { CardHeader, FormControl, InputLabel, Select } from '@mui/material';
import { DemonstrativoType, FiltroReadMovCanal } from '../../canalDist/canalDist.model';

function ChartBarTotalMp(props: CanalDistribuicaoViewProps) { 
  const { chartBarDataAxis, chartBarSeries } = props.canalDistribuicaoState

  const theme = useTheme();
  const colorPalette = [
    (theme.vars || theme).palette.primary.dark,
    (theme.vars || theme).palette.primary.main,
    (theme.vars || theme).palette.primary.light,
  ];

  return (
    <Card variant="outlined" sx={{ width: '100%' }}>
      <CardHeader 
        title="Resumo de Faturamento por Meio de Pagamentos"       
        disableTypography
      >
      </CardHeader>
      <CardContent>
        <BarChart
          borderRadius={8}
          colors={colorPalette}
          xAxis={
            [
              {
                scaleType: 'band',
                categoryGapRatio: 0.5,
                data: chartBarDataAxis,
              },
            ] as any
          }
          series={chartBarSeries}
          height={250}
          margin={{ left: 50, right: 0, top: 20, bottom: 20 }}
          grid={{ horizontal: true }}
          slotProps={{
            legend: {
              hidden: false,
              labelStyle: { fontSize: 10 },

            },
          }}
        />
      </CardContent>
    </Card>
  );
}

export default connect(mapStateToCanalDistribuicaoProps, mapDispatchToCanalDistribuicaoProps)(ChartBarTotalMp);